import { render, staticRenderFns } from "./CorrectList.vue?vue&type=template&id=63b108e2&scoped=true&"
import script from "./CorrectList.vue?vue&type=script&lang=js&"
export * from "./CorrectList.vue?vue&type=script&lang=js&"
import style0 from "./CorrectList.vue?vue&type=style&index=0&id=63b108e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b108e2",
  null
  
)

export default component.exports